// MODULES
import React from "react";

// COMPONENTS
import CheckboxWithName from "@routes/Cob/components/CheckboxWithName/CheckboxWithName";
import FieldsCollection from "@components/FieldsCollection/FieldsCollection";

// HELPERS
import { createClassName } from "@helpers/utils";


export default class Collection extends React.PureComponent {

    render() {
        const { props } = this;
        const { index, fields, onCheckboxChange } = props;
        const classes = createClassName("Cob-Questionnaire-Collection", {
            "first": index === 0,
        })

        return (
            <div className={ classes }>
                <h3>Personuppgiftshantering (GDPR)</h3>

                <div className="description">
                    <p>Undertecknad medger härmed att Bolaget behandlar personuppgifter som lämnas i samband med ingåendet av detta avtal. Personuppgifterna används av Bolaget för öppnande av depå och i övrigt vid händelser förenade med vad som framgår av detta avtal.</p>
                </div>

                <FieldsCollection
                    fields={[
                        {
                            render: (
                                <CheckboxWithName
                                    label="Jag ger mitt medgivande till personuppgiftshantering"
                                    name="checkbox_customer_kyc_gdpr"
                                    value={ fields.checkbox_customer_kyc_gdpr.checked ? "yes" : "no" }
                                    checked={ fields.checkbox_customer_kyc_gdpr.checked }
                                    onChange={ onCheckboxChange }
                                />
                            ),
                        },
                    ]}
                />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Questionnaire/partners/odin/Fields/collections/Collection7.js